module.exports = __webpack_public_path__ + "assets/logo.4fef8aaf.svg";